import { useState, useEffect, Fragment, useRef } from "react";
import { Row, Col, Card, Button, Form, ListGroup } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLoader } from "../../components/Loading";
import {
  faArrowLeft,
  faSave,
  faPrint,
  faStar,
  faClone,
  faPlus,
  faFileImport,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import * as API from "../../api";
import {
  METADATA_PRODUCTO,
  METADATA_NPL,
  METADATA_NPL_FIELDS_TO_UPDATE,
  buildFormDataEditProduct,
  buildFormDataEditProductParticular,
  getMetadataParticularProduct,
} from "./constants";
import {
  METADATA_ACTIVO,
  METADATA_COLATERAL,
  METADATA_COLATERAL_FIELDS_TO_UPDATE,
  buildFormDataEditAsset,
} from "../DetalleActivoSinProducto/constants";
import { CardForm } from "../../components/CardForm";
import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import * as S from "./styles";
import { ModalValidarCreacionProducto } from "../../components/ModalValidarCreacionProducto";
import { ModalAssetProduct } from "../../components/ModalAssetProduct";
import { Dialog } from "../../components/Dialog";
import { ModalDesagruparProducto } from "../../components/ModalDesagruparProducto";
import {
  disabledFalse,
  disabledTrue,
  hiddenFilter,
  hiddenTrue,
  PORTFOLIOS,
  ROLES,
} from "../../constants";
import { useDataContext } from "../../context/DataState";
import { formatSpanishPrice } from "../../helpers/numbersHelpers";
import {
  buildFormDataEditParticularAsset,
  buildFormDataEditTercerosAsset,
  getMetadataAsset,
  getMetadataNewActivoTerceros,
  validateRequiredFields,
  bl2,
  bl,
} from "../DetalleActivoParticular/constants";
import usePermition from "../../constants/usePermition";
import SelectLanguage from "../../components/SelectLanguage/SelectLanguage";

export const DetalleProducto = () => {
  const [valueFilterProduct, setValueFilterProduct] = useState("");
  const [valueFilterAsset, setValueFilterAsset] = useState("");
  const [language, setLanguage] = useState("ES");
  const [data, setData] = useState({});
  const [initData, setInitData] = useState({});
  const [oldProductData, setOldProductData] = useState({});
  const [dataActivos, setDataActivos] = useState([]);
  const [dataActivoIds, setDataActivoIds] = useState([]);
  const [dataActivosInfo, setDataActivosInfo] = useState([]);
  const [dataSelectedActivo, setDataSelectedActivo] = useState({});
  const [dataValidacionProducto, setDataValidacionProducto] = useState({});
  const [codeProduct, setCodeProduct] = useState("");
  const [activoActual, setActivoActual] = useState("0");
  const [activoPrincipal, setActivoPrincipal] = useState("");
  const [validated, setValidated] = useState(false);
  const [isEditableCommercialStatus, setIsEditableCommercialStatus] =
    useState(true);
  const [isForcedActual, setIsForcedActual] = useState(false);
  const [isBlockedActual, setIsBlockedActual] = useState(false);
  const [loader, showLoader, hideLoader] = useLoader();
  const [modalValidarProducto, setModalValidarProducto] = useState(false);
  const [modalAnadirActivos, setModalAnadirActivos] = useState(false);
  const [modalDesagruparProducto, setModalDesagruparProducto] = useState(false);
  const [modalEnviarTablaTemporal, setModalEnviarTablaTemporal] =
    useState(false);
  const [modalCambiarActivoPrincipal, setModalCambiarActivoPrincipal] =
    useState(false);
  const navigate = useNavigate();
  const { idProduct, idAsset } = useParams();
  const [metadataProducto, setMetadataProducto] = useState([]);
  const [disabledSaveAsset, setDisabledSaveAsset] = useState(false);
  const [disabledSaveProd, setDisabledSaveProd] = useState(false);
  const [prinexIDs, setPrinexIds] = useState([]);
  const [sarebCompetitiveStartDate, setSarebCompetitiveStartDate] =
    useState("");
  const [sarebCompetitiveEndDate, setSarebCompetitiveEndDate] = useState("");
  const [metadataActivo, setMetadataActivo] = useState([]);
  const {
    dispatch,
    state: { appLists, user },
  } = useDataContext();
  const { PERMISOS_POR_ROL } = usePermition({ user });

  const currentPortfolio = user?.currentPortfolioID;
  const isNPLPortfolio = currentPortfolio.includes("CAR-NPL");

  const btnEditAsset = useRef(null);

  useEffect(() => {
    document.title = `EC-Light-${isNPLPortfolio ? "NPL" : "Producto"}`;
    loadProduct(idProduct, idAsset, true, false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isNPLPortfolio]);

  useEffect(() => {
    if (data.isBlocked) {
      if ((data.reasonBlock !== null) & (data.reasonBlock !== "")) {
        setDisabledSaveProd(false);
      } else {
        setDisabledSaveProd(true);
      }
    } else {
      setDisabledSaveProd(false);
    }
  }, [data]);

  useEffect(() => {
     if (
      currentPortfolio === PORTFOLIOS.PARTICULARES ||
      currentPortfolio === PORTFOLIOS.TERCEROS
    )
      return;

    if (
      dataSelectedActivo.segmentationPrimary === "Dotacional" ||
      dataSelectedActivo.segmentationPrimary === "Residencial" ||
      dataSelectedActivo.segmentationPrimary === "Rústico"
    ) {
      if (
        dataSelectedActivo.segmentationPrimaryType !== undefined &&
        dataSelectedActivo.segmentationPrimaryType !== null
      ) {
        setDisabledSaveAsset(false);
      } else {
        setDisabledSaveAsset(true);
      }
    } else {
      setDisabledSaveAsset(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSelectedActivo]);

  useEffect(() => {
    const newMetadataProducto = isNPLPortfolio
      ? METADATA_NPL
      : METADATA_PRODUCTO;
    setMetadataProducto(newMetadataProducto);
  }, [isNPLPortfolio]);

  useEffect(() => {
    const newMetadataActivo = isNPLPortfolio
      ? METADATA_COLATERAL
      : METADATA_ACTIVO;
    setMetadataActivo(newMetadataActivo);
  }, [isNPLPortfolio]);

  useEffect(() => {
    setDelegate(dataSelectedActivo.delegationId, appLists.delegationList);
  }, [dataSelectedActivo.delegationId, appLists.delegationList]);

  const productName = isNPLPortfolio ? "NPL" : "Producto";
  const activeName = isNPLPortfolio ? "Colateral" : "Activos";

  const loadProduct = (idProductAux, idAssetAux, isInit) => {
    let defaultAsset;
    if (idProductAux && idAssetAux) {
      showLoader();
      API.obtenerProducto(idProductAux)
        .then((res) => {
          const prod = res.data;
          setCodeProduct(res.data.code);
          setActivoActual(Number(idAssetAux));
          const assetIds = res.data.assetIDs;
          setDataActivoIds(assetIds);
          const defaultAssetId = res.data.defaultAssetId;
          setActivoPrincipal(res.data.defaultAssetId);
          setIsForcedActual(res.data.isForced);
          setIsBlockedActual(res.data.isBlocked);

          //cargar activos
          loadAssets(defaultAssetId, defaultAsset, isInit, prod);
        })
        .catch((error) => {
          if (error.code >= 400 && error.code < 500)
            toast.error(error.msg?.message);
          if (error.code === 401) {
            navigate("/404");
          } else {
            console.error(error);
          }
        })
        .finally(() => hideLoader());
    }
  };

  const loadAssets = (defaultAssetId, defaultAsset, isInit, prod) => {
    showLoader();
    const idsToNumber = prod.assetIDs.map((str) => parseInt(str, 10));
    let data = {
      iDs: idsToNumber,
    };
    API.obtenerActivo(data)
      .then((resAssets) => {
        let listsAux = { ...appLists };
        let newMetadataActivo = [
          ...(isNPLPortfolio ? METADATA_COLATERAL : METADATA_ACTIVO),
        ];
        let auxMDFloor = newMetadataActivo.find((e) => e.id === "suelo");
        if (auxMDFloor) {
          let auxSegField = auxMDFloor.metadata.find(
            (md) => md.name === "segmentation"
          );
          if (auxSegField) {
            auxSegField.disabled = disabledTrue;
          }
        }

        let newMetadataProducto = [
          ...(isNPLPortfolio ? METADATA_NPL : METADATA_PRODUCTO),
        ];
        defaultAsset = resAssets.data.filter((e) => e.id === defaultAssetId)[0];
        prod.segmentationPrimary = defaultAsset.segmentationPrimary;
        prod.segmentationSecondary = defaultAsset.segmentationSecondary;
        prod.segmentationPrimaryType = defaultAsset.segmentationPrimaryType;
        prod.segmentationSecondaryType = defaultAsset.segmentationSecondaryType;

        setData(prod);
        setOldProductData(prod);
        setInitData(prod);

        //Mostrar las razones de bloqueo concatenenando las generales con las de la cartera del usuario
        let listReasonBlock = [
          ...listsAux.reasonBlock.All,
          ...(listsAux.reasonBlock[defaultAsset.portfolioId] || []),
        ];
        listsAux.reasonBlockList = listReasonBlock;

        //Llenar la lista de tipo de red comercial con las opciones generales y las específicas de la cartera
        let listCommercialNT = JSON.parse(
          localStorage.getItem("commercialNetType")
        );
        let listCommercialType = [];
        listCommercialType = [
          ...listCommercialNT.All,
          ...(listCommercialNT[defaultAsset.portfolioId] || []),
        ];
        listsAux.commercialNetType = listCommercialType;

        dispatch({
          type: "UPDATE_APP_LIST",
          payload: listsAux,
        });

        let pIds = [];
        prod.assetIDs.forEach((id) => {
          let PI = {};
          PI.prinexId = resAssets.data.find((e) => e.id === id).prinexId;
          PI.id = id;
          pIds.push(PI);
        });
        setPrinexIds(pIds);

        const newMetadataProductCard = newMetadataProducto.find(
          (e) => e.id === "product" || e.id === "npl"
        );
        //permissionForced
        if (
          currentPortfolio !== PORTFOLIOS.PARTICULARES &&
          currentPortfolio !== PORTFOLIOS.TERCEROS
        ) {
          if (
            prod &&
            (PERMISOS_POR_ROL.SuperAdmin || PERMISOS_POR_ROL.Admin) &&
            (!prod.isAvailable || (prod.isAvailable && prod.isForced))
          ) {
            if (newMetadataProductCard) {
              newMetadataProductCard.metadata.find(
                (e) => e.name === "isForced"
              ).disabled = disabledFalse;
            }
          } else {
            if (newMetadataProductCard) {
              newMetadataProductCard.metadata.find(
                (e) => e.name === "isForced"
              ).disabled = disabledTrue;
            }
          }
        }

        //permissionManualHidePvPAPICRM
        if (
          ((defaultAsset.portfolioId === PORTFOLIOS.NS ||
            defaultAsset.portfolioId === PORTFOLIOS.QUASAR) &&
            (PERMISOS_POR_ROL.AnyAdmin ||
              ((defaultAsset.businessLine === 1 ||
                defaultAsset.businessLine === 2) &&
                PERMISOS_POR_ROL.ComercialDelegate &&
                defaultAsset !== null &&
                defaultAsset.crmPrice <= 1000000))) ||
          (defaultAsset.portfolioId === PORTFOLIOS.SAREB &&
            PERMISOS_POR_ROL.AnyAdmin) ||
          (defaultAsset.portfolioId === PORTFOLIOS.ANTICIPA &&
            PERMISOS_POR_ROL.AnyAdmin) ||
          (PERMISOS_POR_ROL.AnyAdmin &&
            (defaultAsset.portfolioId === PORTFOLIOS.NPL_ANTICIPA ||
              defaultAsset.portfolioId === PORTFOLIOS.NPL_SAREB ||
              defaultAsset.portfolioId === PORTFOLIOS.NPL_QUASAR ||
              defaultAsset.portfolioId === PORTFOLIOS.NPL_TERCEROS))
        ) {
          if (newMetadataProductCard) {
            newMetadataProductCard.metadata.find(
              (e) => e.name === "manualHidePvPAPICRM"
            ).disabled = disabledFalse;
          }
        } else {
          if (newMetadataProductCard) {
            newMetadataProductCard.metadata.find(
              (e) => e.name === "manualHidePvPAPICRM"
            ).disabled = disabledTrue;
          }
        }

        //permissionCommercialInterest
        const auxMdProdCI = newMetadataProducto.find(
          (e) => e.id === "commercialInterest"
        );
        const auxMDScore = auxMdProdCI?.metadata.find(
          (e) => e.name === "commercialInterestScore"
        );
        const auxMDCIDesc = auxMdProdCI?.metadata.find(
          (e) => e.name === "commercialInterestDescription"
        );
        if (PERMISOS_POR_ROL.SuperAdmin || PERMISOS_POR_ROL.ComercialDelegate) {
          if (auxMdProdCI) {
            if (auxMDScore) {
              auxMDScore.disabled = disabledFalse;
            }
            if (auxMDCIDesc) {
              auxMDCIDesc.disabled = disabledFalse;
            }
          }
        } else {
          if (auxMdProdCI) {
            if (auxMDScore) {
              auxMDScore.disabled = disabledTrue;
            }
            if (auxMDCIDesc) {
              auxMDCIDesc.disabled = disabledTrue;
            }
          }
        }

        //permissionCheckBlocked
        const auxMDIsBlocked = newMetadataProductCard?.metadata.find(
          (e) => e.name === "isBlocked"
        );
        let permissionCheckBlocked = false;
        if (
          ((defaultAsset.portfolioId === PORTFOLIOS.NS ||
            defaultAsset.portfolioId === PORTFOLIOS.QUASAR) &&
            (PERMISOS_POR_ROL.AnyAdmin ||
              ((defaultAsset.businessLine === 1 ||
                defaultAsset.businessLine === 2) &&
                PERMISOS_POR_ROL.ComercialDelegate))) ||
          (defaultAsset.portfolioId === PORTFOLIOS.SAREB &&
            PERMISOS_POR_ROL.AnyAdmin) ||
          (defaultAsset.portfolioId === PORTFOLIOS.ANTICIPA &&
            PERMISOS_POR_ROL.AnyAdmin) ||
          (PERMISOS_POR_ROL.AnyAdmin &&
            (defaultAsset.portfolioId === PORTFOLIOS.NPL_ANTICIPA ||
              defaultAsset.portfolioId === PORTFOLIOS.NPL_SAREB ||
              defaultAsset.portfolioId === PORTFOLIOS.NPL_QUASAR ||
              defaultAsset.portfolioId === PORTFOLIOS.NPL_TERCEROS))
        ) {
          if (newMetadataProductCard) {
            auxMDIsBlocked.disabled = disabledFalse;
          }
          permissionCheckBlocked = true;
        } else {
          if (newMetadataProductCard) {
            auxMDIsBlocked.disabled = disabledTrue;
          }
        }

        //permissionReasonBlocked
        if (
          ((defaultAsset.portfolioId === PORTFOLIOS.NS ||
            defaultAsset.portfolioId === PORTFOLIOS.QUASAR) &&
            (PERMISOS_POR_ROL.AnyAdmin ||
              ((defaultAsset.businessLine === 1 ||
                defaultAsset.businessLine === 2) &&
                PERMISOS_POR_ROL.ComercialDelegate))) ||
          (defaultAsset.portfolioId === PORTFOLIOS.SAREB &&
            PERMISOS_POR_ROL.AnyAdmin) ||
          (defaultAsset.portfolioId === PORTFOLIOS.ANTICIPA &&
            PERMISOS_POR_ROL.AnyAdmin) ||
          (PERMISOS_POR_ROL.AnyAdmin &&
            (defaultAsset.portfolioId === PORTFOLIOS.NPL_ANTICIPA ||
              defaultAsset.portfolioId === PORTFOLIOS.NPL_SAREB ||
              defaultAsset.portfolioId === PORTFOLIOS.NPL_QUASAR ||
              defaultAsset.portfolioId === PORTFOLIOS.NPL_TERCEROS))
        ) {
          if (permissionCheckBlocked && prod.isBlocked) {
            if (auxMDIsBlocked) {
              newMetadataProductCard.metadata.find(
                (e) => e.name === "reasonBlock"
              ).disabled =
                prod.reasonBlock === 13 ? disabledTrue : disabledFalse;
            }
          }
        } else {
          if (auxMDIsBlocked) {
            newMetadataProductCard.metadata.find(
              (e) => e.name === "reasonBlock"
            ).disabled = disabledTrue;
          }
        }

        //delegationId
        if (
          currentPortfolio !== PORTFOLIOS.PARTICULARES &&
          currentPortfolio !== PORTFOLIOS.TERCEROS
        ) {
          if (PERMISOS_POR_ROL.AnyAdmin) {
            let mdDelDG = newMetadataActivo
              .find((e) => e.id === "generalData")
              ?.metadata.find((e) => e.name === "delegationId");
            if (mdDelDG) {
              mdDelDG.disabled = defaultAsset.commercialPromotionId
                ? disabledTrue
                : disabledFalse;
            }
          }

          // hidde fields by portfolio
          let headToRemove = [];
          newMetadataActivo.forEach((head) => {
            if (
              !!head.visibleFor?.length &&
              !head.visibleFor?.includes(currentPortfolio)
            ) {
              headToRemove.push(head.id);
            } else {
              head.metadata.forEach((field) => {
                if (!!field.visibleFor?.length) {
                  if (!field.visibleFor.includes(currentPortfolio)) {
                    field.hidden = hiddenTrue;
                  }
                }
              });
            }
          });

          newMetadataActivo = newMetadataActivo.filter(
            (e) => !headToRemove.includes(e.id)
          );

          if (!PERMISOS_POR_ROL.SuperAdmin) {
            newMetadataActivo = newMetadataActivo.filter(
              (e) => e.id !== "audit"
            );
          }
        }

        if (currentPortfolio === PORTFOLIOS.PARTICULARES) {
          newMetadataActivo = getMetadataAsset(prod.defaultAssetId);
        }

        if (currentPortfolio === PORTFOLIOS.TERCEROS) {
          newMetadataActivo = getMetadataNewActivoTerceros(prod.defaultAssetId);
        }

        // hidde/show anticipaPosesion for portfolio anticipa
        let generalData = newMetadataActivo.find((e) => e.id === "generalData");
        if (generalData) {
          const posessionField = generalData.metadata.find(
            (e) => e.name === "anticipaPosesion"
          );

          if (posessionField) {
            posessionField.hidden =
              currentPortfolio !== PORTFOLIOS.ANTICIPA
                ? hiddenTrue
                : hiddenFilter;
          }
        }

        // enble/disable hideNumber
        if (
          currentPortfolio !== PORTFOLIOS.PARTICULARES &&
          currentPortfolio !== PORTFOLIOS.TERCEROS
        ) {
          const locSection = newMetadataActivo.find(
            (e) => e.id === "localization"
          );

          if (locSection) {
            locSection.metadata.find((e) => e.name === "hideNumber").disabled =
              PERMISOS_POR_ROL.DetalleProducto.OcultarNumero
                ? disabledFalse
                : disabledTrue;
          }
        }

        const userRolesArray = user.roles.map((rol) => rol.name);

        if (
          userRolesArray.includes(ROLES.CONTENT_EDITOR) &&
          (currentPortfolio === PORTFOLIOS.QUASAR ||
            currentPortfolio === PORTFOLIOS.SAREB ||
            currentPortfolio === PORTFOLIOS.ANTICIPA)
        ) {
          const granularData = newMetadataActivo.find(
            (e) => e.id === "granular"
          );

          const energyCertificationData = newMetadataActivo.find(
            (e) => e.id === "energyCertification"
          );

          const graphycMaterialData = newMetadataActivo.find(
            (e) => e.id === "graphycMaterial"
          );

          if (granularData) {
            let hasBalconyEDC = granularData.metadata.find(
              (e) => e.name === "hasBalconyEDC"
            );
            hasBalconyEDC.disabled = disabledFalse;

            let heatingType = granularData.metadata.find(
              (e) => e.name === "heatingType"
            );
            heatingType.disabled = disabledFalse;

            let buildingYear = granularData.metadata.find(
              (e) => e.name === "buildingYear"
            );
            buildingYear.disabled = disabledFalse;

            let builtInWardrobe = granularData.metadata.find(
              (e) => e.name === "builtInWardrobe"
            );
            builtInWardrobe.disabled = disabledFalse;

            let buildingStatus = granularData.metadata.find(
              (e) => e.name === "buildingStatus"
            );
            buildingStatus.disabled = disabledFalse;

            let buildingOrientation = granularData.metadata.find(
              (e) => e.name === "buildingOrientation"
            );
            buildingOrientation.disabled = disabledFalse;
          }

          if (energyCertificationData) {
            let heatingEmissions = energyCertificationData.metadata.find(
              (e) => e.name === "heatingEmissions"
            );
            heatingEmissions.disabled = disabledFalse;

            let energyCertification = energyCertificationData.metadata.find(
              (e) => e.name === "energyCertification"
            );
            energyCertification.disabled = disabledFalse;

            let energyConsumption = energyCertificationData.metadata.find(
              (e) => e.name === "energyConsumption"
            );
            energyConsumption.disabled = disabledFalse;

            let emissionsCertification = energyCertificationData.metadata.find(
              (e) => e.name === "emissionsCertification"
            );
            emissionsCertification.disabled = disabledFalse;
          }

          if (graphycMaterialData) {
            let areValidPhotos = graphycMaterialData.metadata.find(
              (e) => e.name === "areValidPhotos"
            );
            areValidPhotos.disabled = disabledFalse;

            let photoDetails = graphycMaterialData.metadata.find(
              (e) => e.name === "photoDetails"
            );
            photoDetails.disabled = disabledFalse;

            let photoComments = graphycMaterialData.metadata.find(
              (e) => e.name === "photoComments"
            );
            photoComments.disabled = disabledFalse;

            let photoDetails2 = graphycMaterialData.metadata.find(
              (e) => e.name === "photoDetails2"
            );
            photoDetails2.disabled = disabledFalse;

            let photoValidation2 = graphycMaterialData.metadata.find(
              (e) => e.name === "photoValidation2"
            );
            photoValidation2.disabled = disabledFalse;

            let tourDetails2 = graphycMaterialData.metadata.find(
              (e) => e.name === "tourDetails2"
            );
            tourDetails2.disabled = disabledFalse;

            let tourValidation = graphycMaterialData.metadata.find(
              (e) => e.name === "tourValidation"
            );
            tourValidation.disabled = disabledFalse;

            let descriptionDetails = graphycMaterialData.metadata.find(
              (e) => e.name === "descriptionDetails"
            );
            descriptionDetails.disabled = disabledFalse;

            let descriptionValidation = graphycMaterialData.metadata.find(
              (e) => e.name === "descriptionValidation"
            );
            descriptionValidation.disabled = disabledFalse;

            let agreeTour = graphycMaterialData.metadata.find(
              (e) => e.name === "agreeTour"
            );
            agreeTour.disabled = disabledFalse;
          }
        }

        if (
          userRolesArray.includes(ROLES.CONTENT_EDITOR) ||
          userRolesArray.includes(ROLES.MARKETING) ||
          userRolesArray.includes(ROLES.SUPERADMIN) ||
          userRolesArray.includes(ROLES.ADMIN)
        ) {
          const basicFeaturesData = newMetadataActivo.find(
            (e) => e.id === "basicFeatures"
          );

          if (basicFeaturesData) {
            const isNew = basicFeaturesData.metadata.find(
              (e) => e.name === "isNew"
            );
            isNew.disabled = disabledFalse;
          }
        }

        if (currentPortfolio === PORTFOLIOS.SAREB) {
          let floorSec = newMetadataActivo.find((e) => e.id === "suelo");
          let basicFeaturesSec = newMetadataActivo.find(
            (e) => e.id === "basicFeatures"
          );
          if (basicFeaturesSec) {
            let curentUseField = basicFeaturesSec.metadata.find(
              (e) => e.name === "currentUse"
            );
            curentUseField.disabled = disabledTrue;
          }
          if (floorSec) {
            let plotAreaField = floorSec.metadata.find(
              (e) => e.name === "plotArea"
            );
            let buildableVolumeField = floorSec.metadata.find(
              (e) => e.name === "buildableVolume"
            );
            plotAreaField.disabled = disabledTrue;
            buildableVolumeField.disabled = disabledTrue;
          }
        }

        setMetadataActivo(newMetadataActivo);

        //Check commercial status editable
        const commercialStatusId = appLists.appNotEditableCommercialStatus.find(
          (e) => e === resAssets.data[0].commercialStatusId
        );
        if (commercialStatusId) {
          setIsEditableCommercialStatus(false);
        }
        //Check para mostrar Suelo
        if (defaultAsset.businessLine !== 1) {
          newMetadataProducto = newMetadataProducto.filter(
            (s) => s.id !== "floor"
          );
        }
        //Check para mostrar Auditoria
        if (!PERMISOS_POR_ROL.SuperAdmin) {
          newMetadataProducto = newMetadataProducto.filter(
            (s) => s.id !== "audit"
          );
        }

        //Click accordions
        if (isInit) {
          let accs = document.getElementsByClassName("accordion-button");
          for (var i = 0, len = accs.length; i < len; i++) {
            if (
              accs[i].innerText === "Suelo" &&
              defaultAsset.businessLine === 1
            ) {
              accs[i].click();
            } else if (
              accs[i].innerText === "Terciario" &&
              defaultAsset.businessLine === 2
            ) {
              accs[i].click();
            } else if (
              accs[i].innerText === "Granular" &&
              defaultAsset.businessLine === 3
            ) {
              accs[i].click();
            } else {
              if (
                accs[i].innerText !== "Suelo" &&
                accs[i].innerText !== "Terciario" &&
                accs[i].innerText !== "Granular"
              ) {
                accs[i].click();
              }
            }
          }
        }

        let manualHidePvPAPICRMAccess =
          PERMISOS_POR_ROL.Private || PERMISOS_POR_ROL.AnyAdmin;

        if (
          currentPortfolio === PORTFOLIOS.PARTICULARES ||
          currentPortfolio === PORTFOLIOS.TERCEROS
        ) {
          newMetadataProducto = getMetadataParticularProduct(
            PERMISOS_POR_ROL.SuperAdmin,
            PERMISOS_POR_ROL.AnyAdmin,
            manualHidePvPAPICRMAccess,
            defaultAsset.crmPrice,
            prod.isBlocked,
            prod.reasonBlock === 13
          );
        }

        // habilitar el chek inSarebCompetitiveProcess si teine los permisos por rol
        if (currentPortfolio === PORTFOLIOS.SAREB) {
          let sarebSection = newMetadataProducto.find((e) => e.id === "sareb");
          if (sarebSection) {
            let inProcessField = sarebSection.metadata.find(
              (e) => e.name === "inSarebCompetitiveProcess"
            );
            if (inProcessField) {
              if (PERMISOS_POR_ROL.DetalleProducto.ProcesoTransparencia) {
                inProcessField.disabled = disabledFalse;
              } else {
                inProcessField.disabled = disabledTrue;
              }
            }
          }
        }
        //Update MD
        let headToRemoveDetalleProducto = [];
        newMetadataProducto.forEach((head) => {
          if (
            !!head.visibleFor?.length &&
            !head.visibleFor?.includes(currentPortfolio)
          ) {
            headToRemoveDetalleProducto.push(head.label);
          } else {
            head.metadata.forEach((field) => {
              if (!!field.visibleFor?.length) {
                if (!field.visibleFor.includes(currentPortfolio)) {
                  field.hidden = hiddenTrue;
                }
              }
            });
          }
        });
        newMetadataProducto = newMetadataProducto.filter(
          (e) => !headToRemoveDetalleProducto.includes(e.label)
        );
        setMetadataProducto(newMetadataProducto);

        let selectedAsset = resAssets.data.find(
          (s) => s.id === Number(idAsset)
        );

        // Si el activo actual no existe (se desagrupó) pone como actual el por defecto
        if (!selectedAsset) {
          selectedAsset = resAssets.data.find(
            (s) => s.id === Number(defaultAssetId)
          );
        }
        setActivoActual(selectedAsset.id);

        let auxAssetsData = [
          ...resAssets.data.map((a) => ({
            ...a,
            businessLine: bl2[a.businessLine],
          })),
        ];

        auxAssetsData.forEach((elem) => {
          const munId = elem.municipalityId;
          if (elem?.photoDetails) {
            const formattedText = elem?.photoDetails.replace(/\|/g, "\n");
            elem.photoDetails = formattedText;
          }
          if (munId) {
            elem.provinceId = appLists.appMunicipalities.find(
              (e) => e.id === munId
            ).provinceId;
            if (selectedAsset.id === elem.id) {
              selectedAsset.provinceId = elem.provinceId;
            }
          }
          if (elem.registralMunicipalityId) {
            let municipality = listsAux.appMunicipalities.find(
              (s) => s.id === elem.registralMunicipalityId
            );
            if (municipality) {
              elem.registralProvinceId = municipality.provinceId;
              selectedAsset.registralProvinceId = municipality.provinceId;
            }
          }

          if (elem.subTypeId) {
            elem.typeId = appLists.appAssetSubTypes.find(
              (e) => e.id === elem.subTypeId
            ).type;
          }

          if (elem.subTypeModId) {
            elem.typeModId = appLists.appAssetSubTypes.find(
              (e) => e.id === elem.subTypeModId
            ).type;
          }
        });

        if (
          currentPortfolio === PORTFOLIOS.PARTICULARES ||
          currentPortfolio === PORTFOLIOS.TERCEROS
        ) {
          selectedAsset.managementCompany = selectedAsset.managementCompanyId;
          if (selectedAsset.municipalityId) {
            selectedAsset.provinceId = appLists.appMunicipalities.find(
              (e) => e.id === selectedAsset.municipalityId
            ).provinceId;
            listsAux.auxMunicipalities = listsAux.appMunicipalities.filter(
              (e) => e.provinceId === selectedAsset.provinceId
            );
          }
          selectedAsset.typeId = appLists.appAssetSubTypes.find(
            (e) => e.id === selectedAsset.subTypeId
          ).type;

          //fill array assets
          auxAssetsData.forEach((as) => {
            as.managementCompany = as.managementCompanyId;
            if (as?.photoDetails) {
              const formattedText = as?.photoDetails.replace(/\|/g, "\n");
              as.photoDetails = formattedText;
            }
            if (
              !isInit &&
              (currentPortfolio === PORTFOLIOS.PARTICULARES ||
                currentPortfolio === PORTFOLIOS.TERCEROS)
            ) {
              const auxCurrentAsset = dataActivos.find((e) => e.id === as.id);
              if (auxCurrentAsset) {
                as.managementCompanyPrinexId =
                  auxCurrentAsset.managementCompanyPrinexId;
              }
            }
            if (as.municipalityId) {
              as.provinceId = appLists.appMunicipalities.find(
                (e) => e.id === as.municipalityId
              ).provinceId;
            }
            as.typeId = appLists.appAssetSubTypes.find(
              (e) => e.id === as.subTypeId
            ).type;

            as.crmPrice = formatSpanishPrice(as.crmPrice.toString().replace(".", ","));
            if (as.internalValuationAmount !== null && as.internalValuationAmount !== undefined) {
              as.internalValuationAmount = formatSpanishPrice(as.internalValuationAmount.toString().replace(".", ","));
            } 
            if (as.heatingEmissions) {
              as.heatingEmissions = as.heatingEmissions
                .toString()
                .replace(".", ",");
            }

            if (as.terraceSurface) {
              as.terraceSurface = as.terraceSurface
                .toString()
                .replace(".", ",");
            }
          });
        }

        // se obtiene selectedAsset de auxAssetsData después de aplicar todas las conversiones
        // para asegurar que tenga los mismos formatos (crmPrice, heatingEmissions, etc.)
        selectedAsset = auxAssetsData.find((a) => a.id === selectedAsset.id) || selectedAsset;

        setDataSelectedActivo(selectedAsset);
        setDataActivos(auxAssetsData);
        setDataActivosInfo(
          resAssets.data.map((s) => ({
            id: s.id,
            prinexId: s.prinexId,
            name: s.name,
            propertyCode: s.propertyCode,
          }))
        );

        //filter subtypes
        let filteredSubTypes = appLists.appAssetSubTypes.filter(
          (el) => el.type === parseInt(selectedAsset.typeId)
        );

        filteredSubTypes = filteredSubTypes
          .sort((a, b) => a.type - b.type)
          .filter(
            (value, index, self) =>
              index === self.findIndex((t) => t.name === value.name)
          );

        let auxSub = appLists.appAssetSubTypes.find(
          (e) => e.id === selectedAsset.subTypeId
        );

        filteredSubTypes = filteredSubTypes.filter(
          (e) => e.name !== auxSub.name
        );
        filteredSubTypes.push(auxSub);

        listsAux.auxAssetSubTypes = filteredSubTypes;

        enableProductBtsGroupField(prod, newMetadataProducto);
        disableProductFieldBts(prod, newMetadataProducto);
        //load users
        if (isInit) {
          loadUsers(
            listsAux,
            defaultAsset.businessLine,
            defaultAsset.portfolioId
          );

          //Llamara a todos las delegaciones
          loadDelegations(
            defaultAsset.businessLine,
            listsAux,
            defaultAsset.portfolioId,
            defaultAsset.delegationId,
            defaultAsset.businessLine,
            defaultAsset.budgetLine,
            auxAssetsData
          );
        }
      })
      .catch((error) => {
        if (error.code >= 400 && error.code < 500)
          toast.error(error.msg?.message);
        if (error.code === 401) {
          navigate("/404");
        } else {
          console.error(error);
        }
      })
      .finally(() => hideLoader());
  };

  /**
   * Habilita el campo 'btsGroup' dentro de la sección de datos generales de un **activo**.
   * si se cumplen las siguientes condiciones:
   * 1. El portafolio actual es 'TERCEROS'.
   * 2. El activo existe.
   * 3. El activo NO tiene datos previamente asignados en su campo 'btsGroup'.
   *
   * @param {object} mainAsset - Objeto que contiene los datos del activo principal,
   * @param {Array<object>} listAssets - Array que contiene los datos de todos los activos,
   * @param {Array<object>} metadataActivo - Array de objetos de metadatos del activo,
   */
  const enableAssetBtsGroupField = (mainAsset, listAssets, metadataActivo) => {
    if (currentPortfolio !== PORTFOLIOS.TERCEROS) return;

    let AssetData = listAssets.find((x) => x.id === Number(mainAsset.id));
    if (!AssetData || AssetData?.btsGroup) return;

    let generalDataSection = metadataActivo.find((e) => e.id === "generalData");
    let btsGroupField =
      generalDataSection?.metadata?.find((x) => x.name === "btsGroup") ??
      undefined;
    if (btsGroupField) btsGroupField.disabled = disabledFalse;
  };

  /**
   * Habilita el campo 'btsGroup' dentro de la sección de datos generales de un **Producto**.
   * si se cumplen las siguientes condiciones:
   * 1. El portafolio actual es 'TERCEROS'.
   * 2. El Producto NO tiene datos previamente asignados en su campo 'btsGroup'.
   * 3. El Producto NO tiene datos previamente asignados en su campo 'bts'.
   *
   * @param {object} productData - Objeto que contiene los datos del producto.
   */
  const enableProductBtsGroupField = (productData, metadataProducto) => {
    if (currentPortfolio !== PORTFOLIOS.TERCEROS) return;
    if (!productData || productData?.btsGroup || productData?.bts) return;

    let productSection = metadataProducto.find((e) => e.id === "product");
    let btsGroupField =
      productSection?.metadata?.find((x) => x.name === "btsGroup") ?? undefined;

    if (!btsGroupField) return;

    btsGroupField.disabled = disabledFalse;
    //Actulizar el estado.
    setMetadataProducto(metadataProducto);
  };

  /**
   * Desabilita el campo 'bts' (Susceptible BTS) dentro de la sección de "datos generales" de un **Producto**.
   * si se cumplen las siguientes condiciones:
   * 1. Si el Campo 'btsGroup' del Producto tiene datos asignados.
   *
   * @param {object} productData - Objeto que contiene los datos del producto.
   */
  const disableProductFieldBts = (productData, metadataProducto) => {
    if (currentPortfolio !== PORTFOLIOS.TERCEROS) return;
    if (!productData || !productData.btsGroup) return;
    let productSection = metadataProducto.find(
      (e) => e.id === "product" || e.id === "npl"
    );
    let btsField =
      productSection?.metadata?.find((x) => x.name === "bts") ?? undefined;
    if (!btsField) return;
    btsField.disabled = disabledTrue;
    //Actulizar el estado.
    setMetadataProducto(metadataProducto);
  };

  const loadUsers = (listsAux, idBL, portfolioId) => {
    showLoader();
    API.obtenerUsuariosList()
      .then((res) => {
        let list = listsAux;
        list.users = res.data;
      })
      .catch((error) => {
        if (error.code >= 400 && error.code < 500)
          toast.error(error.msg?.message);
        console.error(error);
      })
      .finally(() => hideLoader());
  };

  const changeData = (values) => {
    const newMetadataProducto = [...metadataProducto];
    const newData = { ...data };
    newData.isBlocked = values.isBlocked;
    newData.reasonBlock = values.reasonBlock;

    if (values.isBlocked) {
      if (newData.reasonBlock !== null && newData.reasonBlock !== "") {
        setDisabledSaveProd(false);
      } else {
        setDisabledSaveProd(true);
      }
    } else {
      newData.reasonBlock = "";
    }
    let MDReason = newMetadataProducto
      .find((el) => el.id === "product" || el.id === "npl")
      .metadata.find((e) => e.name === "reasonBlock");
    if (values.isBlocked !== isBlockedActual) {
      if (values.isBlocked) {
        MDReason.disabled = disabledFalse;
        MDReason.required = true;
        if (values.reasonBlock !== null && values.reasonBlock !== "") {
          setDisabledSaveProd(false);
        } else {
          setDisabledSaveProd(true);
        }
        newData.isPublishable = false;
      } else {
        MDReason.disabled = disabledTrue;
        MDReason.required = false;
        setDisabledSaveProd(false);
        newData.reasonBlock = "";
      }
      setIsBlockedActual(values.isBlocked);
    }

    setMetadataProducto(newMetadataProducto);
    setData(newData);
  };

  const loadDelegations = (
    idBL,
    auxList,
    portfolioId,
    delegationId,
    businessLine,
    budgetLine,
    auxAssetsData
  ) => {
    showLoader();
    API.obtenerDelegaciones()
      .then((res) => {
        //Se verefica el dato de "businessLine" que viene por parametro, de manera que siempre el dato que se asigne a la variable "businessLineId" sea el ID de la linea de negocio.
        //A veces el parametro viene con datos como "Granular" y otras con el ID.
        let businessLineId = Number.isInteger(businessLine)
          ? businessLine
          : bl[businessLine];

        const businessDelegations = res.data.filter(
          (e) =>
            currentPortfolio === PORTFOLIOS.TERCEROS ||
            e.businessLine === businessLineId
        );
        const userDelegations = user.delegations;
        const delegationsUserList = businessDelegations.filter((e) =>
          userDelegations.includes(e.id)
        );
        const assetDelegation = res.data.find((e) => e.id === delegationId);

        ///
        const delegationsForList = delegationsUserList
          .filter(
            (e) =>
              e.portfolioId === portfolioId &&
              (!e.budgetLine || e.budgetLine === budgetLine)
          )
          // se filtra por territorial (excepto para la cartera ANTICIPA Y TERCEROS)
          .filter(
            (s) =>
              currentPortfolio === PORTFOLIOS.ANTICIPA ||
              currentPortfolio === PORTFOLIOS.TERCEROS ||
              s.territorialId === assetDelegation.territorialId
          );
        let tempLists = auxList;
        tempLists.delegationList = delegationsForList;

        if (
          currentPortfolio === PORTFOLIOS.PARTICULARES ||
          currentPortfolio === PORTFOLIOS.TERCEROS
        ) {
          getAllManagmentCompanies(auxList, auxAssetsData);
        } else {
          dispatch({
            type: "UPDATE_APP_LIST",
            payload: tempLists,
          });
        }
      })
      .catch((error) => {
        if (error.code >= 400 && error.code < 500)
          toast.error(error.msg?.message);
        console.error(error);
      })
      .finally(() => hideLoader());
  };

  const getAllManagmentCompanies = (list, auxAssetsData) => {
    showLoader();
    API.obtenerSociedadesGestoras()
      .then((res) => {
        let auxList = { ...list };
        let auxManagmentCompanyList = res.data.filter(
          (e) => e.portfolioId === currentPortfolio
        );
        const sociedadesGestorasList = auxManagmentCompanyList.map((item) => ({
          Id: item.prinexId,
          name: item.name,
        }));

        auxList.managmentCompanyList = sociedadesGestorasList || [];
        let auxDataAssets = [...auxAssetsData];
        if (currentPortfolio === PORTFOLIOS.PARTICULARES) {
          auxDataAssets.forEach((e) => {
            e.managementCompanyPrinexId = auxManagmentCompanyList[0]?.prinexId;
            e.managementCompanyId = auxManagmentCompanyList[0]?.id;
            e.managementCompany = auxManagmentCompanyList[0]?.name;
            e.managementCompanyNif = auxManagmentCompanyList[0]?.cif;
            e.managementCompanyAddress = auxManagmentCompanyList[0]?.address;
          });
        } else {
          const selectedManagmentCompany = auxManagmentCompanyList.find(
            (e) => e.prinexId === auxDataAssets[0].managementCompanyId
          );
          auxDataAssets.forEach((e) => {
            e.managementCompanyPrinexId = selectedManagmentCompany?.prinexId;
            e.managementCompanyId = selectedManagmentCompany?.prinexId;
            e.managementCompany = selectedManagmentCompany?.name;
            e.managementCompanyNif = selectedManagmentCompany?.cif;
            e.managementCompanyAddress = selectedManagmentCompany?.address;
          });
        }

        setDataActivos(auxDataAssets);

        dispatch({
          type: "UPDATE_APP_LIST",
          payload: auxList,
        });
      })
      .catch((e) => console.error(e))
      .finally(hideLoader);
  };

  const getDataToPut = (metadata, data) => {
    const dataToPut = {};
    metadata.forEach(({ field, type }) => {
      switch (type) {
        case "text":
          dataToPut[field] = data[field] || "";
          break;

        case "number":
          const parsedValue = parseFloat(data[field]);
          dataToPut[field] = isNaN(parsedValue) ? null : parsedValue;
          break;

        case "boolean":
          dataToPut[field] = !!data[field];
          break;

        case "triState":
          switch (data[field]) {
            case true:
            case "true":
              dataToPut[field] = true;
              break;

            case false:
            case "false":
              dataToPut[field] = false;
              break;

            default:
              dataToPut[field] = null;
              break;
          }
          break;

        default:
          dataToPut[field] = data[field];
      }
    });
    return dataToPut;
  };

  const handleSubmitEditProduct = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      if (idProduct) {
        let saveProductService;
        let productData;
        let updateAssetsBtsGroup = false;

        switch (currentPortfolio) {
          case PORTFOLIOS.QUASAR:
          case PORTFOLIOS.NS:
          case PORTFOLIOS.SAREB:
          case PORTFOLIOS.ANTICIPA:
            saveProductService = API.editarProducto;
            productData = buildFormDataEditProduct(data);
            productData.defaultAssetId = Number(activoPrincipal);
            break;

          case PORTFOLIOS.PARTICULARES:
            saveProductService = API.editarProductoParticulares;
            productData = buildFormDataEditProductParticular(data);
            productData.defaultAssetId = Number(activoPrincipal);
            break;

          case PORTFOLIOS.TERCEROS:
            // Validación de campos obligatorios para Terceros
            const validationErrors = validateTercerosRequiredFields(data);
            if (validationErrors.length > 0) {
              validationErrors.forEach((error) => toast.error(error));
              return;
            }

            saveProductService = API.editarProductoTerceros;
            productData = buildFormDataEditProductParticular(data);
            productData.defaultAssetId = Number(activoPrincipal);
            if (dataSelectedActivo.btsGroup !== productData.btsGroup) {
              updateAssetsBtsGroup = true;
              setDataSelectedActivo((prev) => ({
                ...prev,
                btsGroup: productData.btsGroup,
              }));
            }
            break;

          case PORTFOLIOS.NPL_ANTICIPA:
          case PORTFOLIOS.NPL_SAREB:
          case PORTFOLIOS.NPL_QUASAR:
          case PORTFOLIOS.NPL_TERCEROS:
            saveProductService = API.editarProductoNPL;
            productData = getDataToPut(METADATA_NPL_FIELDS_TO_UPDATE, data);
            break;

          default:
            break;
        }

        showLoader();
        saveProductService(productData)
          .then((res) => {
            toast.success("Producto editado correctamente");

            if (updateAssetsBtsGroup) btnEditAsset.current.click();

            const prod = res.data;
            const defaultAssetId = prod.defaultAssetId;
            setCodeProduct(prod.code);
            setActivoPrincipal(defaultAssetId);
            setIsForcedActual(prod.isForced);
            setIsBlockedActual(prod.isBlocked);

            loadAssets(defaultAssetId, {}, false, prod);
          })
          .catch((error) => {
            console.error(error);
            setDataSelectedActivo((prev) => ({ ...prev, btsGroup: "" }));
          })
          .finally(hideLoader);
      }
    }
  };

  const handleChangeForced = (values) => {
    const newData = { ...data };
    newData.isForced = values.isForced;
    const newMetadataProducto = [...metadataProducto];
    if (values.isForced === isForcedActual) {
      newData.isAvailable = oldProductData.isAvailable;
      newData.status = oldProductData.status;
      newData.isBlocked = oldProductData.isBlocked;
      newData.reasonBlock = oldProductData.reasonBlock;
      newData.comments = oldProductData.comments;
    } else if (values.isForced !== isForcedActual && values.isForced) {
      newData.isAvailable = true;
      newData.status = 0;
      newData.isBlocked = true;
      newData.reasonBlock = 10;
      newData.comments = "";
    }

    const newMetadataProductCard = newMetadataProducto.find(
      (e) => e.id === "product" || e.id === "npl"
    );
    const mdRBAux = newMetadataProductCard?.metadata.find(
      (e) => e.name === "reasonBlock"
    );
    if (newData.isBlocked) {
      if (newMetadataProductCard) {
        if (mdRBAux) {
          mdRBAux.disabled = disabledFalse;
        }
      }
    } else {
      mdRBAux.disabled = disabledTrue;
    }
    if (newData.reasonBlock === null) {
      newData.reasonBlock = "";
    }
    setData(newData);
    setMetadataProducto(newMetadataProducto);
  };

  const handleSubmitEditAsset = (event) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();

    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      if (activoActual) {
        let saveAssetService;
        let assetData;
        let emptyReguiredFields;

        switch (currentPortfolio) {
          case PORTFOLIOS.QUASAR:
          case PORTFOLIOS.NS:
          case PORTFOLIOS.SAREB:
          case PORTFOLIOS.ANTICIPA:
            saveAssetService = API.editarActivo;

            assetData = buildFormDataEditAsset(dataSelectedActivo);
            assetData.id = activoActual;
            if (assetData.delegationId)
              assetData.delegationId = parseInt(assetData.delegationId);
            else if (assetData.delegationId === "") {
              toast.error("La delegación es obligatoria");
              return false;
            }
            if (assetData.commercialNetType)
              assetData.commercialNetType = parseInt(
                assetData.commercialNetType
              );
            else if (assetData.commercialNetType === "")
              assetData.commercialNetType = null;
            if (assetData.garageType)
              assetData.garageType = parseInt(assetData.garageType);
            else if (assetData.garageType === "") assetData.garageType = null;
            break;

          case PORTFOLIOS.PARTICULARES:
            saveAssetService = API.editarActivoParticular;

            emptyReguiredFields = validateRequiredFields(
              dataSelectedActivo,
              activoActual
            );
            if (emptyReguiredFields.length === 0) {
              assetData = buildFormDataEditParticularAsset(dataSelectedActivo);
            } else {
              const singular = emptyReguiredFields.length === 1;
              const errorMsg = `${singular ? "El" : "Los"} campo${
                singular ? "" : "s "
              }${
                singular
                  ? ` ${emptyReguiredFields[0].label} `
                  : `[${emptyReguiredFields.map((e) => `${e.label}`)}]`
              }${singular ? " es" : " son"} obligatorio${singular ? "" : "s"}`;
              toast.error(errorMsg.replaceAll(",", ", "));
            }
            break;

          case PORTFOLIOS.TERCEROS:
            saveAssetService = API.editarActivoTerceros;

            emptyReguiredFields = validateRequiredFields(
              dataSelectedActivo,
              activoActual
            );
            if (emptyReguiredFields.length === 0) {
              assetData = buildFormDataEditTercerosAsset(dataSelectedActivo);
            } else {
              const singular = emptyReguiredFields.length === 1;
              const errorMsg = `${singular ? "El" : "Los"} campo${
                singular ? "" : "s "
              }${
                singular
                  ? ` ${emptyReguiredFields[0].label} `
                  : `[${emptyReguiredFields.map((e) => `${e.label}`)}]`
              }${singular ? " es" : " son"} obligatorio${singular ? "" : "s"}`;
              toast.error(errorMsg.replaceAll(",", ", "));
            }
            break;

          case PORTFOLIOS.NPL_ANTICIPA:
          case PORTFOLIOS.NPL_SAREB:
          case PORTFOLIOS.NPL_QUASAR:
          case PORTFOLIOS.NPL_TERCEROS:
            saveAssetService = API.editarColateral;
            assetData = getDataToPut(
              METADATA_COLATERAL_FIELDS_TO_UPDATE,
              dataSelectedActivo
            );
            break;

          default:
            break;
        }

        showLoader();
        saveAssetService(assetData)
          .then((res) => {
            toast.success("Editado correctamente");
            loadProduct(idProduct, idAsset, false);
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(hideLoader);
      }
    }
  };

  const onLanguageChange = ({ target: { value } }) => {
    setLanguage(value);
  };

  const validateProduct = () => {
    showLoader();
    API.validarProducto(idProduct)
      .then((res) => {
        setDataValidacionProducto(res.data);
        setModalValidarProducto(true);
      })
      .catch((error) => console.error(error))
      .finally(() => hideLoader());
  };

  const confirmAnadirActivosProducto = (value) => {
    setModalAnadirActivos(false);
    const dataSend = {};
    dataSend.defaultAssetId = Number(activoPrincipal);
    dataSend.assetIDs = dataActivoIds.concat(value);
    if (
      currentPortfolio !== PORTFOLIOS.PARTICULARES &&
      currentPortfolio !== PORTFOLIOS.TERCEROS
    ) {
      dataSend.segmentationPrimary = data.segmentationPrimary;
      dataSend.segmentationSecondary = data.segmentationSecondary;
      dataSend.segmentationPrimaryType = data.segmentationPrimaryType;
      dataSend.segmentationSecondaryType = data.segmentationSecondaryType;
      showLoader();
      API.crearProducto(dataSend)
        .then((res) => {
          toast.success("Activos añadidos correctamente");
          navigate(
            "/product-detail/" + res.data.id + "/" + res.data.defaultAssetId
          );
          const prod = res.data;
          const defaultAssetId = res.data.defaultAssetId;
          const assetIds = res.data.assetIDs;
          setDataActivoIds(assetIds);
          setCodeProduct(prod.code);

          //cargar activos
          loadAssets(defaultAssetId, {}, false, prod);
          // loadProduct(res.data.id, res.data.defaultAssetId, false);
        })
        .catch((error) => {
          if (error.code >= 400 && error.code < 500)
            toast.error(error.msg?.message);
          console.error(error);
        })
        .finally(hideLoader);
    } else {
      showLoader();
      const serviceForCrearProducto =
        currentPortfolio === PORTFOLIOS.PARTICULARES
          ? API.crearProductoParticulares
          : API.crearProductoTerceros;

      if (currentPortfolio === PORTFOLIOS.TERCEROS) {
        dataSend.btsGroup = data.btsGroup;
        dataSend.espCondCode = data.espCondCode;
        dataSend.probabilitySale6Months = data.probabilitySale6Months;
        dataSend.probabilitySale12Months = data.probabilitySale12Months;
        dataSend.estimatedTimeSell = data.estimatedTimeSell;
      }
      serviceForCrearProducto(dataSend)
        .then((res) => {
          toast.success("Activos añadidos correctamente");
          navigate(
            "/product-detail/" + res.data.id + "/" + res.data.defaultAssetId
          );
          const prod = res.data;
          const defaultAssetId = res.data.defaultAssetId;
          const assetIds = res.data.assetIDs;
          setDataActivoIds(assetIds);
          setCodeProduct(prod.code);

          //cargar activos
          loadAssets(defaultAssetId, {}, false, prod);
          // loadProduct(res.data.id, res.data.defaultAssetId, false);
        })
        .catch((error) => {
          // if (error.code >= 400 && error.code < 500)
          //   toast.error(error.msg?.message);
          console.error(error);
        })
        .finally(hideLoader);
    }
  };

  const confirmEnviarTablaTemporal = () => {
    showLoader();
    setModalEnviarTablaTemporal(false);
    let data = {};
    API.enviarTablaTemporalProducto(idProduct, data)
      .then((res) => {
        toast.success("Producto enviado a tabla temporal");
      })
      .catch((error) => {
        if (error.code >= 400 && error.code < 500)
          toast.error(error.msg?.message);
        console.error(error);
      })
      .finally(() => {
        hideLoader();
      });
  };

  const confirmCambiarActivoPrincipal = () => {
    const form = document.getElementById("editProduct");
    setModalCambiarActivoPrincipal(false);
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      if (idProduct) {
        if (
          currentPortfolio !== PORTFOLIOS.PARTICULARES &&
          currentPortfolio !== PORTFOLIOS.TERCEROS
        ) {
          let formData = buildFormDataEditProduct(
            initData,
            Number(activoPrincipal)
          );
          formData.defaultAssetId = parseInt(activoActual);
          showLoader();
          API.editarProducto(formData)
            .then((res) => {
              toast.success("Producto editado correctamente");
              const prod = res.data;
              const defaultAssetId = res.data.defaultAssetId;
              setActivoPrincipal(defaultAssetId);
              const assetIds = res.data.assetIDs;
              setDataActivoIds(assetIds);
              setCodeProduct(prod.code);

              //cargar activos
              loadAssets(defaultAssetId, {}, false, prod);
            })
            .catch((error) => {
              if (error.code >= 400 && error.code < 500)
                toast.error(error.msg?.message);
              console.error(error);
            })
            .finally(() => hideLoader());
        } else {
          const serviceForCambiarActivoPrincipal =
            currentPortfolio === "CAR-PARTI"
              ? API.editarProductoParticulares
              : API.editarProductoTerceros;

          let formData = buildFormDataEditProductParticular(data);
          formData.defaultAssetId = parseInt(activoActual);

          setModalCambiarActivoPrincipal(false);
          showLoader();
          serviceForCambiarActivoPrincipal(formData)
            .then((result) => {
              toast.success("Producto editado correctamente");
              const prod = result.data;
              const defaultAssetId = result.data.defaultAssetId;
              setActivoPrincipal(defaultAssetId);
              const assetIds = result.data.assetIDs;
              setDataActivoIds(assetIds);
              setCodeProduct(prod.code);

              //cargar activos
              loadAssets(defaultAssetId, {}, false, prod);
            })
            .catch((e) => console.error(e))
            .finally(hideLoader);
        }
      }
    }
  };

  const confirmDesagrupar = (selected) => {
    setModalDesagruparProducto(false);
    let dataSend = {};
    dataSend.defaultAssetId = Number(activoPrincipal);
    dataSend.assetIDs = dataActivoIds.filter((s) => !selected.includes(s));
    data.assetIDs = dataSend.assetIDs;
    if (
      currentPortfolio !== PORTFOLIOS.PARTICULARES &&
      currentPortfolio !== PORTFOLIOS.TERCEROS
    ) {
      dataSend.segmentationPrimary = data.segmentationPrimary;
      dataSend.segmentationSecondary = data.segmentationSecondary;
      dataSend.segmentationPrimaryType = data.segmentationPrimaryType;
      dataSend.segmentationSecondaryType = data.segmentationSecondaryType;
      showLoader();
      API.desagruparProducto(data, "true")
        .then((res) => {
          toast.success("Producto desagrupado correctamente");
          navigate(
            "/product-detail/" + res.data.id + "/" + res.data.defaultAssetId
          );
          const prod = res.data;
          const defaultAssetId = res.data.defaultAssetId;
          const assetIds = res.data.assetIDs;
          setDataActivoIds(assetIds);
          setCodeProduct(prod.code);

          //cargar activos
          loadAssets(defaultAssetId, {}, false, prod);
        })
        .catch((error) => {
          if (error.code >= 400 && error.code < 500)
            toast.error(error.msg?.message);
          console.error(error);
        })
        .finally(() => {
          hideLoader();
        });
    } else {
      showLoader();
      const serviceForDesagrupar =
        currentPortfolio === "CAR-PARTI"
          ? API.desagruparProductoParticulares
          : API.desagruparProductoTerceros;

      if (currentPortfolio === PORTFOLIOS.TERCEROS) {
        dataSend.btsGroup = data.btsGroup;
        dataSend.espCondCode = data.espCondCode;
        dataSend.probabilitySale6Months = data.probabilitySale6Months;
        dataSend.probabilitySale12Months = data.probabilitySale12Months;
        dataSend.estimatedTimeSell = data.estimatedTimeSell;
      }

      serviceForDesagrupar(dataSend, "true")
        .then((result) => {
          toast.success("Producto desagrupado correctamente");
          navigate(
            "/product-detail/" +
              result.data.id +
              "/" +
              result.data.defaultAssetId
          );
          const prod = result.data;
          const defaultAssetId = result.data.defaultAssetId;
          const assetIds = result.data.assetIDs;
          setDataActivoIds(assetIds);
          setCodeProduct(prod.code);

          //cargar activos
          loadAssets(defaultAssetId, {}, false, prod);
        })
        .catch((e) => console.error(e))
        .finally(hideLoader);
    }
  };

  const confirmDesagruparTodos = () => {
    setModalDesagruparProducto(false);
    const dataSend = {};
    dataSend.defaultAssetId = Number(activoPrincipal);
    dataSend.assetIDs = [Number(activoPrincipal)];
    data.assetIDs = dataSend.assetIDs;
    if (
      currentPortfolio !== PORTFOLIOS.PARTICULARES &&
      currentPortfolio !== PORTFOLIOS.TERCEROS
    ) {
      dataSend.segmentationPrimary = data.segmentationPrimary;
      dataSend.segmentationSecondary = data.segmentationSecondary;
      dataSend.segmentationPrimaryType = data.segmentationPrimaryType;
      dataSend.segmentationSecondaryType = data.segmentationSecondaryType;
      showLoader();
      API.desagruparProducto(data, "false")
        .then((res) => {
          toast.success("Producto desagrupado correctamente");
          navigate(
            "/product-detail/" + res.data.id + "/" + res.data.defaultAssetId
          );
          const prod = res.data;
          const defaultAssetId = res.data.defaultAssetId;
          const assetIds = res.data.assetIDs;
          setDataActivoIds(assetIds);
          setCodeProduct(prod.code);

          //cargar activos
          loadAssets(defaultAssetId, {}, false, prod);
        })
        .catch((error) => {
          if (error.code >= 400 && error.code < 500)
            toast.error(error.msg?.message);
          console.error(error);
        })
        .finally(() => {
          hideLoader();
        });
    } else {
      showLoader();
      const serviceForDesagruparTodos =
        currentPortfolio === "CAR-PARTI"
          ? API.desagruparProductoParticulares
          : API.desagruparProductoTerceros;

      if (currentPortfolio === PORTFOLIOS.TERCEROS) {
        dataSend.btsGroup = data.btsGroup;
        dataSend.espCondCode = data.espCondCode;
        dataSend.probabilitySale6Months = data.probabilitySale6Months;
        dataSend.probabilitySale12Months = data.probabilitySale12Months;
        dataSend.estimatedTimeSell = data.estimatedTimeSell;
      }

      serviceForDesagruparTodos(dataSend, "false")
        .then((result) => {
          toast.success("Producto desagrupado correctamente");
          navigate(
            "/product-detail/" +
              result.data.id +
              "/" +
              result.data.defaultAssetId
          );
          const prod = result.data;
          const defaultAssetId = result.data.defaultAssetId;
          const assetIds = result.data.assetIDs;
          setDataActivoIds(assetIds);
          setCodeProduct(prod.code);

          //cargar activos
          loadAssets(defaultAssetId, {}, false, prod);
        })
        .catch((e) => console.error(e))
        .finally(hideLoader);
    }
  };

  const defaultSortActivos = [
    {
      id: "prinexId",
      desc: false,
    },
  ];

  const handleSelectedAssetDataChange = (formData) => {
    const urlPattern =
      /(?:https?):\/\/(\w+:?\w*)?(\S+)(:\d+)?(\/|\/([\w#!:.?+=&%!-.?+=&%!-]))?/;
    if (
      formData.urlVirtualTour !== null &&
      formData.urlVirtualTour !== "" &&
      !!urlPattern.test(formData.urlVirtualTour)
    ) {
      formData.hasPlans = true;
    } else {
      formData.hasPlans = false;
    }

    const regex = /[^0-9,]/g;

    const decimalFields = [
      "buildingAboveGroundM2",
      "freeResidentialM2",
      "protectedResidentialM2",
      "terciaryM2",
      "comercialM2",
      "industrialM2",
      "hoteliersM2",
      "othersM2",
      "officeM2",
      "warehouseM2",
      "groundFloorM2",
      "firstFloorM2",
      "secondFloorM2",
      "usefulM2",
      "builtM2",
      "terraceSurface",
      "freeHeight",
      "grossM2",
      "betsM2",
      "plotArea",
      "buildableVolume",
      "energyCertificationPerfomance",
      "energyCertificateEmissionsValue",
    ];

    const integerFields = [
      "households",
      "freeHouseholds",
      "protectedFreeHouseholds",
      "buildableHomes",
      "floorAmount",
      "roomsNumber",
      "piers",
      "gates",
      "parkingPlacesAmount",
      "bedrooms",
      "bathrooms",
      "aboveGroundFloorAmount",
      "category",
      "keyDeliveryYear",
      "keyDeliveryMonth",
      "buildableFloors",
      "liftsNumber",
      "parkingSpacesNumber",
      "nearestLocationKm",
      "operationPriceCommunity",
    ];

    decimalFields.forEach((field) => {
      if (!!formData[field]) {
        const newNVal = formData[field].toString().replace(".", ",");
        formData[field] = newNVal.replace(regex, "");
      }
    });

    integerFields.forEach((field) => {
      if (!!formData[field]) {
        formData[field] = formData[field].toString().replace(/[^0-9]/g, "");
      }
    });

    const rangeFields = [
      { field: "keyDeliveryMonth", min: 1, max: 12 },
      { field: "buildableFloors", min: 1, max: 99 },
      { field: "nearestLocationKm", min: 0, max: 99 },
      { field: "liftsNumber", min: 0, max: 9 },
      { field: "parkingSpacesNumber", min: 1, max: 99 },
    ];

    rangeFields.forEach(({ field, min, max }) => {
      if (formData[field] !== undefined && formData[field] !== "") {
        const val = parseInt(formData[field], 10);
        if (!isNaN(val)) {
          formData[field] = Math.min(Math.max(val, min), max).toString();
        }
      }
    });

    if (formData.urbanization && formData.urbanization.length > 50) {
      formData.urbanization = formData.urbanization.substring(0, 50);
    }

    setDataSelectedActivo(formData);
  };

  const validateTercerosRequiredFields = (productData) => {
    const errors = [];

    // Validar Probabilidad de Venta a 6 Meses
    if (
      productData.probabilitySale6Months === null ||
      productData.probabilitySale6Months === undefined ||
      productData.probabilitySale6Months === ""
    ) {
      errors.push("Probabilidad de Venta a 6 Meses es obligatorio");
    } else if (
      productData.probabilitySale6Months <= 0 ||
      productData.probabilitySale6Months > 100
    ) {
      errors.push("Probabilidad de Venta a 6 Meses debe estar entre 1 y 100");
    }

    // Validar Probabilidad de Venta a 12 Meses
    if (
      productData.probabilitySale12Months === null ||
      productData.probabilitySale12Months === undefined ||
      productData.probabilitySale12Months === ""
    ) {
      errors.push("Probabilidad de Venta a 12 Meses es obligatorio");
    } else if (
      productData.probabilitySale12Months <= 0 ||
      productData.probabilitySale12Months > 100
    ) {
      errors.push("Probabilidad de Venta a 12 Meses debe estar entre 1 y 100");
    }

    // Validar Plazo Estimado de Venta
    if (
      !productData.estimatedTimeSell ||
      productData.estimatedTimeSell.trim() === ""
    ) {
      errors.push("Plazo Estimado de Venta es obligatorio");
    }

    return errors;
  };

  const handleDataPARTChange = (values) => {
    if (!!values.garagesAmount) {
      const newValue = values.garagesAmount.toString().replace(/[^0-9]/g, "");
      values.garagesAmount = newValue;
    }
    if (!!values.storagesAmount) {
      const newValue = values.storagesAmount.toString().replace(/[^0-9]/g, "");
      values.storagesAmount = newValue;
    }

    setData(values);
  };

  const handleParticularAssetDataChange = (values, prop) => {
    let auxLists = { ...appLists };

    // Campos con formato decimal (permiten coma)
    const decimalFields = [
      "buildingAboveGroundM2",
      "freeResidentialM2",
      "protectedResidentialM2",
      "terciaryM2",
      "comercialM2",
      "industrialM2",
      "hoteliersM2",
      "othersM2",
      "officeM2",
      "warehouseM2",
      "groundFloorM2",
      "firstFloorM2",
      "secondFloorM2",
      "usefulM2",
      "builtM2",
      "terraceSurface",
      "freeHeight",
      "grossM2",
      "betsM2",
      "plotArea",
      "buildableVolume",
      "energyCertificationPerfomance",
      "energyCertificateEmissionsValue",
    ];

    // Campos enteros estrictos (no permiten coma ni punto)
    const integerFields = [
      "households",
      "freeHouseholds",
      "protectedFreeHouseholds",
      "buildableHomes",
      "floorAmount",
      "roomsNumber",
      "piers",
      "gates",
      "parkingPlacesAmount",
      "bedrooms",
      "bathrooms",
      "aboveGroundFloorAmount",
      "category",
      "keyDeliveryYear",
      "keyDeliveryMonth",
      "buildableFloors",
      "liftsNumber",
      "parkingSpacesNumber",
      "nearestLocationKm",
      "operationPriceCommunity",
    ];

    //actualizar lista de municipios
    let municipalities = appLists.appMunicipalities;
    if (!!values.provinceId) {
      auxLists.auxMunicipalities = municipalities.filter(
        (mun) => mun.provinceId === values.provinceId
      );
    } else {
      // values.municipalityId = "";
      auxLists.auxMunicipalities = municipalities;
    }

    //Replace
    const regex = /[^0-9,]/g;
    
    if (!!values.crmPrice && prop === "crmPrice") {
      values.crmPrice = formatSpanishPrice(values.crmPrice);
    }
    if (!!values.internalValuationAmount && prop === "internalValuationAmount") {
      values.internalValuationAmount = formatSpanishPrice(values.internalValuationAmount);
    }
    const coordinateRegex = /^-?\d*([.,]\d*)?/;
    if (!!values.latitude) {
      const match = values.latitude.toString().match(coordinateRegex);
      values.latitude = match ? match[0] : "";
    }
    if (!!values.longitude) {
      const match = values.longitude.toString().match(coordinateRegex);
      values.longitude = match ? match[0] : "";
    }

    if (!!values.mandateDuration) {
      const mandateDuration = values.mandateDuration.toString();
      const newValue = mandateDuration.replace(/[^0-9,]/g, "");
      if (newValue.length <= 9) {
        values.mandateDuration = newValue;
      } else {
        values.mandateDuration = newValue.slice(0, 9);
      }
    }
    if (!!values.heatingEmissions) {
      const newNVal = values.heatingEmissions.toString().replace(".", ",");
      const newValue = newNVal.replace(regex, "");
      values.heatingEmissions = newValue;
    }
    if (!!values.buildingYear) {
      const newValue = values.buildingYear.toString().replace(/[^0-9]/g, "");
      if (newValue.length <= 4) {
        values.buildingYear = newValue;
      } else {
        values.buildingYear = newValue.slice(0, 4);
      }
    }

    decimalFields.forEach((field) => {
      if (!!values[field]) {
        const newNVal = values[field].toString().replace(".", ",");
        values[field] = newNVal.replace(regex, "");
      }
    });

    integerFields.forEach((field) => {
      if (!!values[field]) {
        values[field] = values[field].toString().replace(/[^0-9]/g, "");
      }
    });

    const rangeFields = [
      { field: "keyDeliveryMonth", min: 1, max: 12 },
      { field: "buildableFloors", min: 1, max: 99 },
      { field: "nearestLocationKm", min: 0, max: 99 },
      { field: "liftsNumber", min: 0, max: 9 },
      { field: "parkingSpacesNumber", min: 1, max: 99 },
    ];

    rangeFields.forEach(({ field, min, max }) => {
      if (values[field] !== undefined && values[field] !== "") {
        const val = parseInt(values[field], 10);
        if (!isNaN(val)) {
          values[field] = Math.min(Math.max(val, min), max).toString();
        }
      }
    });

    if (values.urbanization && values.urbanization.length > 50) {
      values.urbanization = values.urbanization.substring(0, 50);
    }

    //full direction
    if (
      !!values.road &&
      values.typeOfRoad !== "-Seleccionar-" &&
      !!values.number
    ) {
      values.fullAddress =
        values.typeOfRoad + ": " + values.road + ", " + values.number;
    } else {
      delete values.fullAddress;
    }

    //handle type/subTypeif (!!values.typeId) {
    const newMetadataActivo = [...metadataActivo];
    const mdSubType = newMetadataActivo
      .find((header) => header.id === "features")
      .metadata.find((md) => md.name === "subTypeId");
    if (!!values.typeId) {
      mdSubType.disabled = disabledFalse;
      const filteredSubTypes = appLists.appAssetSubTypes.filter(
        (el) => el.type === parseInt(values.typeId)
      );

      auxLists.auxAssetSubTypes = filteredSubTypes
        .sort((a, b) => a.type - b.type)
        .filter(
          (value, index, self) =>
            index === self.findIndex((t) => t.name === value.name)
        );
      mdSubType.hidden = hiddenFilter;
    } else {
      values.subTypeId = "";
      mdSubType.disabled = disabledTrue;
    }

    dispatch({
      type: "UPDATE_APP_LIST",
      payload: auxLists,
    });

    // validation percentage
    if (
      prop === "wipPercentage" ||
      prop === "scopePercent" ||
      prop === "ownershipPercent"
    ) {
      const validatedValue = validatePercentageValue(values[prop]);
      if (validatedValue !== null) {
        values[prop] = validatedValue;
      } else {
        // Si es inválido, restauramos el valor anterior del estado
        values[prop] = dataSelectedActivo[prop];
      }
    }

    setMetadataActivo(newMetadataActivo);
    setDataSelectedActivo(values);
  };

  const handleAuditLink = (entityName) => {
    navigate(
      `/auditing?EntityName=${entityName}&EntityId=${
        entityName === "Asset" ? activoActual : data.id
      }`
    );
  };

  const orderActivos = (activos, activoPrincipal) => {
    return activos.sort((a, b) => {
      if (Number(a.id) === activoPrincipal) return -1;
      if (Number(b.id) === activoPrincipal) return 1;
      return 0;
    });
  };

  const orderedPrinexIDs = orderActivos(prinexIDs, activoPrincipal);

  const handleChangeInProcess = (values) => {
    let auxData = { ...data };
    if (!values.inSarebCompetitiveProcess) {
      setSarebCompetitiveStartDate(values.sarebCompetitiveStartDate);
      setSarebCompetitiveEndDate(values.sarebCompetitiveEndDate);
      auxData.sarebCompetitiveStartDate = "";
      auxData.sarebCompetitiveEndDate = "";
      auxData.inSarebCompetitiveProcess = false;
    } else {
      auxData.sarebCompetitiveStartDate = sarebCompetitiveStartDate;
      auxData.sarebCompetitiveEndDate = sarebCompetitiveEndDate;
      auxData.inSarebCompetitiveProcess = true;
    }
    setData(auxData);
  };

  /**
   * Maneja el cambio del campo 'bts' y habilita/deshabilita el campo 'btsGroup' según corresponda.
   * Si bts es true, deshabilita btsGroup. Si bts es false, habilita btsGroup.
   *
   * @param {object} values - Objeto con los valores del formulario
   */
  const handleChangeBts = (values) => {
    const newMetadataProducto = [...metadataProducto];
    const newData = { ...data };
    newData.bts = values.bts;

    const productSection = newMetadataProducto.find((e) => e.id === "product");
    const btsGroupField = productSection?.metadata?.find(
      (e) => e.name === "btsGroup"
    );

    if (values.bts) {
      if (btsGroupField) {
        btsGroupField.disabled = disabledTrue;
        newData.btsGroup = "";
      }
    } else {
      if (btsGroupField) {
        btsGroupField.disabled = disabledFalse;
      }
    }

    setMetadataProducto(newMetadataProducto);
    setData(newData);
  };

  /**
   * Maneja el cambio del check 'webBookingAvailable' y cambia el valor del check 'onlineSale' según corresponda.
   * Si 'webBookingAvailable' es true, cambia a 'true' el check de 'onlineSale' y viceversa.
   *
   * @param {object} values - Objeto con los valores del formulario
   */
  const handleCheckWebBookingAvailable = (values) => {
    const newMetadataProducto = [...metadataProducto];
    const newData = { ...data };
    newData.webBookingAvailable = values.webBookingAvailable;

    const productSection = newMetadataProducto.find((e) => e.id === "product");
    const onlineSaleCheck = productSection?.metadata?.find(
      (e) => e.name === "onlineSale"
    );

    if (!onlineSaleCheck) return;

    if (newData.espCondCode) {
      showUniqueError(
        "Los campos 'Venta Online Exclusiva' y 'Código Condiciones Especiales' son incompatibles."
      );
      return;
    }

    if (values.webBookingAvailable) {
      newData.onlineSale = true;
    } else {
      newData.onlineSale = false;
    }

    setMetadataProducto(newMetadataProducto);
    setData(newData);
  };

  /**
   * Maneja el cambio del campo 'espCondCode' y cambia el valor del check 'onlineSale' según corresponda.
   * Si 'espCondCode contiene' datos, se cambia a 'true' el valor del check 'onlineSale' y viceversa.
   *
   * @param {object} values - Objeto con los valores del formulario
   */
  const handleChangeEspCondCode = (values) => {
    const newMetadataProducto = [...metadataProducto];
    const newData = { ...data };
    newData.espCondCode = values.espCondCode;

    const productSection = newMetadataProducto.find((e) => e.id === "product");
    const onlineSaleCheck = productSection?.metadata?.find(
      (e) => e.name === "onlineSale"
    );

    if (!onlineSaleCheck) return;

    if (newData.webBookingAvailable) {
      showUniqueError(
        "Los campos 'Venta Online Exclusiva' y 'Código Condiciones Especiales' son incompatibles."
      );
      return;
    }

    if (values.espCondCode) {
      newData.onlineSale = true;
    } else {
      newData.onlineSale = false;
    }

    setMetadataProducto(newMetadataProducto);
    setData(newData);
  };

  /**
   * **Muestra un mensaje de error único.**
   *
   * Este método evita que el mismo mensaje de error se muestre
   * múltiples veces de forma consecutiva. Si un toast con el mismo
   * `toastId` ya está activo, no se volverá a disparar.
   * @param {string} msg - El mensaje de error que se mostrará en el toast.
   * @param {string} [id="conflictError"] - Identificador único del toast.
   *                                        Si no se indica, se usará "conflictError".
   */
  const showUniqueError = (msg, id = "conflictError") => {
    if (!toast.isActive(id)) {
      toast.error(msg, { toastId: id });
    }
  };

  /**
   * **Establece el delegado del activo.**
   *
   * @param {number} delegationId - El ID de la delegación.
   */

  const setDelegate = (delegationId, delegationList) => {
    if (!delegationId || !delegationList) return;
    const delegation = delegationList.find(
      (x) => x.id === Number(delegationId)
    );
    if (!delegation) return;
    setDataSelectedActivo((prev) => ({
      ...prev,
      delegate: delegation.delegate || "",
    }));
  };

  /**
   * **Valida y formatea valores de porcentaje (0-100) con hasta 2 decimales.**
   *
   * Función pura que valida y formatea un valor de porcentaje.
   * Acepta números enteros o decimales entre 0 y 100, permitiendo hasta 2 decimales
   * separados por coma. Convierte automáticamente puntos a comas.
   *
   * Ejemplos válidos: 0, 50, 99, 100, 0,5, 50,75, 99,99, 100
   *
   * @param {string|number} rawValue - Valor a validar.
   * @returns {string|null} - Valor validado o null si no es válido.
   */
  const validatePercentageValue = (rawValue) => {
    let valuePercentage = String(rawValue ?? "");

    // Convertir punto a coma automáticamente
    valuePercentage = valuePercentage.replace(/\./g, ",");

    // Regex: 0–100, coma como decimal, máx. 2 decimales
    const regex = /^(100(?:,0{1,2})?|[0-9]{1,2}(?:,[0-9]{0,2})?)$/;

    if (valuePercentage === "") {
      return "";
    }

    if (regex.test(valuePercentage)) {
      return valuePercentage;
    }

    return null;
  };

  /**
   * **Valida y actualiza un campo de porcentaje para PRODUCTOS.**
   *
   * @param {Object} values - Objeto con los valores del formulario.
   * @param {string} property - Nombre de la propiedad a validar.
   * @returns {void}
   */
  const handlePercentageForProduct = (values, property) => {
    const validatedValue = validatePercentageValue(values[property]);

    if (validatedValue !== null) {
      values[property] = validatedValue;
      setData(values);
    }
  };

  //region return
  return (
    <S.DetailPage>
      {loader}
      {modalEnviarTablaTemporal && (
        <Dialog
          type="noFooter"
          message="Se enviará el producto a una tabla temporal, ¿desea continuar?"
          labelConfirm="Continuar"
          confirm={confirmEnviarTablaTemporal}
          cancel={() => setModalEnviarTablaTemporal(false)}
          value={{}}
        />
      )}
      {modalCambiarActivoPrincipal && (
        <Dialog
          type="noFooter"
          message="Se cambiará el activo principal, ¿desea continuar?"
          labelConfirm="Continuar"
          confirm={confirmCambiarActivoPrincipal}
          cancel={() => setModalCambiarActivoPrincipal(false)}
          value={{}}
        />
      )}
      {modalValidarProducto && (
        <ModalValidarCreacionProducto
          message="Validar producto"
          cancel={() => setModalValidarProducto(false)}
          data={dataValidacionProducto}
          idProduct={idProduct}
        />
      )}
      {modalAnadirActivos && (
        <ModalAssetProduct
          id={idProduct}
          message="Añadir activos al producto"
          lists={appLists}
          defaultSort={defaultSortActivos}
          hiddenColumns={["id"]}
          labelConfirm="Guardar"
          cancel={() => setModalAnadirActivos(false)}
          confirm={confirmAnadirActivosProducto}
          showLoader={showLoader}
          hideLoader={hideLoader}
        />
      )}
      {modalDesagruparProducto && (
        <ModalDesagruparProducto
          message="Seleccionar activos"
          cancel={() => setModalDesagruparProducto(false)}
          data={dataActivosInfo.filter((s) => activoPrincipal !== s.id)}
          defaultAsset={activoPrincipal}
          confirmDesagrupar={confirmDesagrupar}
          confirmDesagruparTodos={confirmDesagruparTodos}
        />
      )}

      <Row style={{ marginTop: "1rem", marginBottom: "1rem" }}>
        <Col>
          <S.Title>
            Código de {productName} {isNPLPortfolio ? data.nplId : codeProduct}
          </S.Title>
        </Col>
      </Row>

      <Row>
        {/* //region columna Producto/NPL */}
        <Col>
          <Form noValidate id="editProduct" validated={validated}>
            <Card>
              <Card.Header>
                <h4>{productName}</h4>
                <Row className="mb-3">
                  <Col xs={2}>
                    <Button
                      variant="danger"
                      onClick={() => navigate(-1)}
                      style={{ marginRight: "1rem" }}
                    >
                      <span>
                        <FontAwesomeIcon
                          icon={faArrowLeft}
                          size="sm"
                          fixedWidth
                        />
                      </span>
                    </Button>
                  </Col>
                  <Col xs={9}>
                    <Form.Control
                      type="text"
                      placeholder="Filtrar campos"
                      onChange={(e) => {
                        setValueFilterProduct(e.target.value);
                      }}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs={12}>
                    <Button
                      style={{ marginRight: "1rem" }}
                      variant="success"
                      hidden={!PERMISOS_POR_ROL.DetalleProducto.Auditoria}
                      onClick={() => handleAuditLink("Product")}
                    >
                      <span>
                        <FontAwesomeIcon icon={faPrint} size="sm" fixedWidth />
                      </span>
                      Auditoría
                    </Button>
                    <Button
                      style={{ marginRight: "1rem" }}
                      variant="success"
                      onClick={() => validateProduct()}
                      hidden={!PERMISOS_POR_ROL.DetalleProducto.ValidarProducto}
                    >
                      <span>
                        <FontAwesomeIcon icon={faCheck} size="sm" fixedWidth />
                      </span>
                      Validar
                    </Button>
                    <Button
                      type="button"
                      form="editProduct"
                      variant="success"
                      hidden={
                        !isEditableCommercialStatus ||
                        !PERMISOS_POR_ROL.DetalleProducto.Guardar
                      }
                      disabled={disabledSaveProd}
                      onClick={handleSubmitEditProduct}
                    >
                      <span>
                        <FontAwesomeIcon icon={faSave} size="sm" fixedWidth />
                      </span>
                      Guardar
                    </Button>
                  </Col>
                </Row>
              </Card.Header>

              {/* //region datos Producto/NPL */}
              <Card.Body>
                {metadataProducto.map((field, i) => {
                  return (
                    <CardForm
                      key={i}
                      metadata={field.metadata}
                      label={field.label}
                      id={field.id}
                      collapsable={field.collapsable}
                      filter={valueFilterProduct}
                      language={language}
                      languageSensitive={field.languageSensitive}
                      lists={appLists}
                      data={data}
                      setData={(values, prop) => {
                        if (prop === "isForced") {
                          handleChangeForced(values);
                        } else if (prop === "isBlocked") {
                          changeData(values);
                        } else if (prop === "bts") {
                          handleChangeBts(values);
                        } else if (prop === "webBookingAvailable") {
                          handleCheckWebBookingAvailable(values);
                        } else if (prop === "espCondCode") {
                          handleChangeEspCondCode(values);
                        } else if (
                          currentPortfolio === PORTFOLIOS.PARTICULARES
                        ) {
                          handleDataPARTChange(values);
                        } else if (prop === "inSarebCompetitiveProcess") {
                          handleChangeInProcess(values);
                        } else if (
                          prop === "probabilitySale6Months" ||
                          prop === "probabilitySale12Months"
                        ) {
                          handlePercentageForProduct(values, prop);
                        } else {
                          setData(values);
                        }
                      }}
                    />
                  );
                })}
              </Card.Body>
            </Card>
          </Form>
        </Col>

        {/* //region columna Activo/Colateral */}
        <Col>
          <Form noValidate id="editAsset" validated={validated}>
            <Card>
              <Card.Header>
                <h4>
                  {activeName} <S.NumActivos>{dataActivos.length}</S.NumActivos>
                </h4>
                <Row className="mt-3 mb-3">
                  <Col xs={6}>
                    <Form.Control
                      type="text"
                      placeholder="Filtrar campos"
                      onChange={(e) => {
                        setValueFilterAsset(e.target.value);
                      }}
                    />
                  </Col>
                  <Col xs={6}>
                    <SelectLanguage
                      language={language}
                      onLanguageChange={onLanguageChange}
                    />
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={12}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        style={{ marginRight: "1rem" }}
                        variant="danger"
                        hidden={
                          !isEditableCommercialStatus ||
                          !PERMISOS_POR_ROL.DetalleProducto.Guardar ||
                          isNPLPortfolio
                        }
                        disabled={!(dataActivoIds.length > 1)}
                        onClick={() => setModalDesagruparProducto(true)}
                      >
                        <span>
                          <FontAwesomeIcon
                            icon={faClone}
                            size="sm"
                            fixedWidth
                          />
                        </span>
                        Desagrupar {productName}
                      </Button>
                      <Button
                        style={{ marginRight: "1rem" }}
                        variant="success"
                        onClick={() => setModalAnadirActivos(true)}
                        hidden={
                          !isEditableCommercialStatus ||
                          !PERMISOS_POR_ROL.DetalleProducto.Guardar ||
                          isNPLPortfolio
                        }
                      >
                        <span>
                          <FontAwesomeIcon icon={faPlus} size="sm" fixedWidth />
                        </span>
                        Añadir {activeName}
                      </Button>
                      <Button
                        variant="success"
                        onClick={() => setModalEnviarTablaTemporal(true)}
                        hidden={
                          !isEditableCommercialStatus ||
                          !PERMISOS_POR_ROL.DetalleProducto.EnviarTablaTemporal
                        }
                      >
                        <span>
                          <FontAwesomeIcon
                            icon={faFileImport}
                            size="sm"
                            fixedWidth
                          />
                        </span>
                        Enviar a Tabla Temporal
                      </Button>
                    </div>
                  </Col>
                </Row>
              </Card.Header>

              <Card.Body>
                <Row>
                  <Col xs={2}>
                    <ListGroup>
                      {orderedPrinexIDs.map((activo, i) => (
                        <Fragment key={i}>
                          {Number(activo.id) === activoPrincipal &&
                          !isNPLPortfolio ? (
                            <ListGroup.Item
                              key={i}
                              onClick={() => {
                                const dataAsset = dataActivos.find(
                                  (s) => s.id === Number(activo.id)
                                );

                                if (
                                  currentPortfolio === PORTFOLIOS.PARTICULARES
                                ) {
                                  let auxLists = { ...appLists };
                                  auxLists.auxMunicipalities =
                                    auxLists.appMunicipalities.filter(
                                      (e) =>
                                        e.provinceId === dataAsset.provinceId
                                    );

                                  auxLists.auxAssetSubTypes =
                                    auxLists.appAssetSubTypes.filter(
                                      (e) => e.typeId === dataAsset.type
                                    );

                                  dispatch({
                                    type: "UPDATE_APP_LIST",
                                    payload: auxLists,
                                  });
                                }

                                setDataSelectedActivo(dataAsset);
                                setActivoActual(activo.id);
                              }}
                              style={
                                Number(activoActual) === Number(activo.id)
                                  ? {
                                      color: "#3c8dbc",
                                      cursor: "pointer",
                                      border: "1px solid #ff0e49",
                                      borderRight: "0",
                                      backgroundColor: "#fff",
                                      borderTopRightRadius: "0",
                                      borderBottomRightRadius: "0",
                                      borderTopLeftRadius: "0",
                                      borderBottomLeftRadius: "0",
                                    }
                                  : {
                                      color: "#3c8dbc",
                                      cursor: "pointer",
                                    }
                              }
                            >
                              <span>
                                <FontAwesomeIcon
                                  icon={faStar}
                                  fixedWidth
                                  size="sm"
                                />
                              </span>
                              {activo.prinexId}
                            </ListGroup.Item>
                          ) : (
                            <ListGroup.Item
                              id={`asset${activo.id}`}
                              onClick={() => {
                                const dataAsset = dataActivos.find(
                                  (s) => s.id === Number(activo.id)
                                );

                                if (
                                  currentPortfolio === PORTFOLIOS.PARTICULARES
                                ) {
                                  let auxLists = { ...appLists };
                                  auxLists.auxMunicipalities =
                                    auxLists.appMunicipalities.filter(
                                      (e) =>
                                        e.provinceId === dataAsset.provinceId
                                    );

                                  auxLists.auxAssetSubTypes =
                                    auxLists.appAssetSubTypes.filter(
                                      (e) => e.typeId === dataAsset.type
                                    );

                                  dispatch({
                                    type: "UPDATE_APP_LIST",
                                    payload: auxLists,
                                  });
                                }

                                setDataSelectedActivo(dataAsset);
                                setActivoActual(activo.id);
                              }}
                              style={
                                activoActual === activo.id
                                  ? {
                                      color: "#3c8dbc",
                                      cursor: "pointer",
                                      border: "1px solid #ff0e49",
                                      borderRight: "0",
                                      backgroundColor: "#fff",
                                      borderTopRightRadius: "0",
                                      borderBottomRightRadius: "0",
                                      borderTopLeftRadius: "0",
                                      borderBottomLeftRadius: "0",
                                    }
                                  : {
                                      color: "#3c8dbc",
                                      cursor: "pointer",
                                    }
                              }
                            >
                              {activo.prinexId}
                            </ListGroup.Item>
                          )}
                        </Fragment>
                      ))}
                    </ListGroup>
                  </Col>

                  <Col xs={10}>
                    <div
                      style={{
                        marginBottom: "1rem",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <Button
                        style={{ marginRight: "1rem" }}
                        variant="success"
                        hidden={!PERMISOS_POR_ROL.DetalleProducto.Auditoria}
                        onClick={() => handleAuditLink("Asset")}
                      >
                        <span>
                          <FontAwesomeIcon
                            icon={faPrint}
                            size="sm"
                            fixedWidth
                          />
                        </span>
                        Auditoría
                      </Button>
                      {!isNPLPortfolio && (
                        <Button
                          style={{ marginRight: "1rem" }}
                          variant="success"
                          onClick={() => setModalCambiarActivoPrincipal(true)}
                          disabled={activoActual === Number(activoPrincipal)}
                          hidden={
                            !isEditableCommercialStatus ||
                            !PERMISOS_POR_ROL.DetalleProducto.Guardar
                          }
                        >
                          <span>
                            <FontAwesomeIcon
                              icon={faStar}
                              size="sm"
                              fixedWidth
                            />
                          </span>
                          Activo Principal
                        </Button>
                      )}
                      <Button
                        ref={btnEditAsset}
                        type="button"
                        form="editAsset"
                        variant="success"
                        hidden={
                          !isEditableCommercialStatus ||
                          !PERMISOS_POR_ROL.DetalleProducto.Guardar
                        }
                        disabled={disabledSaveAsset}
                        onClick={handleSubmitEditAsset}
                      >
                        <span>
                          <FontAwesomeIcon icon={faSave} size="sm" fixedWidth />
                        </span>
                        Guardar
                      </Button>
                    </div>
                    {/* //region datos Activo/Colateral */}
                    {/* {JSON.stringify(metadataActivo)} */}
                    {metadataActivo.map((field, index) => (
                      <CardForm
                        key={index}
                        metadata={field.metadata}
                        label={field.label}
                        id={field.id}
                        collapsable={field.collapsable}
                        filter={valueFilterAsset}
                        language={language}
                        languageSensitive={field.languageSensitive}
                        lists={appLists}
                        data={dataSelectedActivo}
                        setData={(values, prop) => {
                          if (
                            currentPortfolio === PORTFOLIOS.PARTICULARES ||
                            currentPortfolio === PORTFOLIOS.TERCEROS
                          ) {
                            handleParticularAssetDataChange(values, prop);
                          } else {
                            handleSelectedAssetDataChange(values);
                          }
                        }}
                      />
                    ))}
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Form>
        </Col>
      </Row>
    </S.DetailPage>
  );
};
